'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/_react@15.7.0@react/react.js
// module id = 1
// module chunks = 0